import { Smartphone, Brain, Code2, Search, Megaphone, LayoutDashboard, Sparkles } from "lucide-react";

export const SERVICES = [
  {
    id: "mobile",
    icon: Smartphone,
    title: "Mobile Apps",
    tag: "iOS · Android · Cross-Platform",
    desc: "Native-feel apps with React Native, Swift & Kotlin. Ship pixel-perfect experiences that feel instant on every device.",
    points: ["React Native + Expo", "Native Swift & Kotlin modules", "Offline-first architecture", "Push, payments & analytics"],
    color: "#00F0FF",
  },
  {
    id: "ai-websites",
    icon: Sparkles,
    title: "AI-Powered Websites",
    tag: "Intelligent · Personalized · Fast",
    desc: "Websites that think. Semantic search, smart recommendations, generative content, and conversational interfaces baked in.",
    points: ["LLM-driven search & chat", "Generative UI & content", "Vector databases", "Edge-rendered performance"],
    color: "#FF00FF",
  },
  {
    id: "custom-ai",
    icon: Brain,
    title: "Custom AI for Business",
    tag: "Fine-Tuned · Private · Scalable",
    desc: "We build bespoke AI agents, copilots, and RAG systems trained on your company's data — deployed on your infrastructure.",
    points: ["RAG pipelines", "Multi-agent systems", "Fine-tuned models", "On-prem or cloud"],
    color: "#39FF14",
  },
  {
    id: "software",
    icon: Code2,
    title: "Software Development",
    tag: "Web · Desktop · APIs",
    desc: "From MVP to enterprise platform. Battle-tested stacks, clean architecture, and teams that ship.",
    points: ["Full-stack engineering", "Microservices & APIs", "DevOps & cloud infra", "QA automation"],
    color: "#00F0FF",
  },
  {
    id: "seo",
    icon: Search,
    title: "SEO Engineering",
    tag: "Technical · Content · Growth",
    desc: "Data-driven SEO. Technical audits, schema, content strategy, and AI-assisted topic clusters that rank.",
    points: ["Technical SEO audit", "Core Web Vitals", "Programmatic SEO", "Content ops"],
    color: "#FF00FF",
  },
  {
    id: "marketing",
    icon: Megaphone,
    title: "Marketing",
    tag: "Brand · Performance · Automation",
    desc: "Full-funnel performance marketing, creative production, and growth automation powered by AI.",
    points: ["Paid media strategy", "Creative studio", "Lifecycle automation", "Analytics & attribution"],
    color: "#39FF14",
  },
  {
    id: "saas",
    icon: LayoutDashboard,
    title: "SaaS Platforms",
    tag: "Multi-tenant · Billing · Scale",
    desc: "We build SaaS from zero: auth, billing, admin, dashboards. Launch a production-grade product in weeks, not years.",
    points: ["Multi-tenant architecture", "Stripe billing & plans", "Admin dashboards", "Scales to millions"],
    color: "#00F0FF",
  },
];
